import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/Header/navbar.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ModalCookie/modal-cookie.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/Others/back-top.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/abfpush-image-optimizer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/add-script-client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/error-suppressor.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/html-from-wp.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/html/cliquefatos-headless/src/app/Components/ScriptsClient/service-worker-register.js");
;
import(/* webpackMode: "eager" */ "/var/www/html/cliquefatos-headless/src/app/globals.css");
